import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SolUserModalComponent } from '../shared/sol-user-modal.component';
import { DEFAULT_MODAL_OPTIONS } from '../shared/constants/app.constants';

/**
 * One place for the "you are a Sanlam Online customer" popup, so every page that can meet such a user
 * (register, login, forgot password) opens the same popup with the same Continue behaviour.
 */
@Injectable({ providedIn: 'root' })
export class SolUserModalService {

  private modalRef: NgbModalRef | null = null;

  constructor(private readonly modalService: NgbModal) { }

  /** Opens the popup. Continue sends the user to the Sanlam Online login page. Safe to call twice. */
  show(): void {
    if (this.modalRef) {
      return;
    }

    const modalRef = this.modalService.open(SolUserModalComponent, { ...DEFAULT_MODAL_OPTIONS, keyboard: false });
    this.modalRef = modalRef;
    modalRef.result.then(
      () => this.continueToSol(),
      () => { /* dismissed (e.g. browser back) - stay where we are */ }
    ).finally(() => { this.modalRef = null; });
  }

  private continueToSol(): void {
     globalThis.location.assign(globalThis.location.origin + '/scs-consent');
  }
}
